export enum Types {
	DOCUMENT = 'document',
	VIDEO = 'video',
	AUDIO = 'audio',
	IMAGE = 'image'
}
